import { z } from 'zod';

export const GeoPoint = z.object({
  latitude: z.number().finite(),
  longitude: z.number().finite(),
  address: z.string().optional(),
});

export const DirectionsResponse = z.object({
  status: z.string().optional(),
  result: z
    .object({
      coordinates: z.array(
        z.object({ latitude: z.number(), longitude: z.number() })
      ).optional(),
      overview: z
        .object({ 
          distanceValue: z.number().optional(),
          durationValue: z.number().optional(),
          distance: z.string().optional(),
          duration: z.string().optional(),
        })
        .passthrough()
        .optional(),
      legs: z
        .array(
          z.object({ 
            distance: z.object({ value: z.number().optional(), text: z.string().optional() }).passthrough().optional(),
            duration: z.object({ value: z.number().optional(), text: z.string().optional() }).passthrough().optional(),
          }).passthrough()
        )
        .optional(),
      distanceValue: z.number().optional(),
      durationValue: z.number().optional(),
      distance: z.string().optional(),
      duration: z.string().optional(),
    })
    .passthrough()
    .optional(),
  coordinates: z
    .array(z.object({ latitude: z.number(), longitude: z.number() }))
    .optional(),
}).passthrough();

export const PricingTransportResponse = z.object({
  price: z.number().optional(),
  suggestedPrice: z.number().optional(),
  currency: z.string().optional(),
  breakdown: z.any().optional(),
}).passthrough();

export { PricingQuoteResponseSchema as PricingEstimateResponse } from '@erunna/contracts-schema';
